import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Text, TextTypes } from '../index';
import './footer.scss';
import { constants } from '../../constants';

interface FooterProps {
    history: any;
}

const Footer = ({ history }: FooterProps) => {
    const { CUSTOMER_SUPPORT_LINK, PRIVACY_POLICY_LINK } = constants;

    return (
        <Container fluid className="footer">
            <Row className="justify-content-around d-none d-md-flex">
                <div onClick={() => history.push('/faq')}>
                    <Text type={TextTypes.SUB2} color={'white'} className="link">
                        FAQ
                    </Text>
                </div>
                <div
                    onClick={() => {
                        let win = window.open(CUSTOMER_SUPPORT_LINK, '_blank');
                        win && win.focus();
                    }}
                >
                    <Text type={TextTypes.SUB2} color={'white'} className="link">
                        Customer Support Page
                    </Text>
                </div>
                <a href={PRIVACY_POLICY_LINK} target="_blank">
                    <Text type={TextTypes.SUB2} color={'white'} className="link">
                        Privacy Policy
                    </Text>
                </a>
            </Row>
            <Row className="d-md-none d-sm-flex">
                <Col xs={5} onClick={() => history.push('/faq')}>
                    <Text type={TextTypes.SUB2} color={'white'} className="link">
                        FAQ
                    </Text>
                </Col>
                <Col
                    xs={7}
                    onClick={() => {
                        let win = window.open(CUSTOMER_SUPPORT_LINK, '_blank');
                        win && win.focus();
                    }}
                >
                    <Text type={TextTypes.SUB2} color={'white'} className="link">
                        Customer Support
                    </Text>
                </Col>
            </Row>
            <Row className="d-md-none d-sm-flex">
                <Col xs={5}>
                    <a href={PRIVACY_POLICY_LINK} target="_blank">
                        <Text type={TextTypes.SUB2} color={'white'} className="link">
                            Privacy Policy
                        </Text>
                    </a>
                </Col>
                <Col />
            </Row>
        </Container>
    );
};

export default Footer;
